import { rgba } from 'polished';

export const primitive = {
  yellow: {
    10: '#4B2F0F',
    9: '#673E0D',
    8: '#844B08',
    7: '#AA5D04',
    6: '#D37300',
    5: '#FFC233',
    4: '#FED75C',
    3: '#FEE678',
    2: '#FFF2B6',
    1: '#FFF7DA',
  },
  orange: {
    10: '#45220D',
    9: '#642E0D',
    8: '#8A3B0C',
    7: '#AD480C',
    6: '#D25309',
    5: '#FF8D4B',
    4: '#FFAB52',
    3: '#FCC47C',
    2: '#FFDEC0',
    1: '#FFEADD',
  },
  red: {
    10: '#5C101B',
    9: '#6D0F1C',
    8: '#8B0C1E',
    7: '#9D091E',
    6: '#BF0712',
    5: '#D9352C',
    4: '#FB6B6B',
    3: '#FDAAAA',
    2: '#FFD9DD',
    1: '#FFEEEE',
  },
  violet: {
    10: '#2B0B39',
    9: '#400E57',
    8: '#551174',
    7: '#6B1393',
    6: '#8012B3',
    5: '#A538D7',
    4: '#BD61DD',
    3: '#D291E9',
    2: '#F4D7FF',
    1: '#F6E7FB',
  },
  purple: {
    10: '#1F084C',
    9: '#350C73',
    8: '#4B11A1',
    7: '#6210CC',
    6: '#7129E5',
    5: '#8E64FA',
    4: '#A184FF',
    3: '#CABDFF',
    2: '#E1DBFF',
    1: '#F0EEFF',
  },
  blue: {
    10: '#171743',
    9: '#212161',
    8: '#30308F',
    7: '#4141B2',
    6: '#5959D3',
    5: '#5589ED',
    4: '#79A2F2',
    3: '#ADC9FF',
    2: '#D4E5FF',
    1: '#E7F1FF',
  },
  green: {
    10: '#082621',
    9: '#083730',
    7: '#066858',
    8: '#084D42',
    6: '#027D69',
    5: '#259C72',
    4: '#69C085',
    3: '#A5D9A8',
    2: '#D1F0D3',
    1: '#E2FAE4',
  },
  neutral: {
    10: '#0D0D0D',
    9: '#2E2E2E',
    8: '#424242',
    7: '#5E5E5E',
    6: '#858585',
    5: '#A6A6A6',
    4: '#CCCCCC',
    3: '#E0E0E0',
    2: '#ECECEC',
    1: '#F7F7F7',
  },
};

export const foundation = {
  primary: primitive.purple[7],
  white: '#FFFFFF',
  black: primitive.neutral[10],
  negative: primitive.red[5],
  positive: primitive.green[5],
  warning: primitive.yellow[5],
};

export const core = {
  bg: {
    1: foundation.white,
    2: primitive.neutral[1],
    3: primitive.neutral[2],
    disabled: primitive.neutral[2],
    black: primitive.neutral[10],
    primary: {
      default: primitive.purple[7],
      disabled: primitive.purple[3],
      light: primitive.purple[2],
    },
    inverse: {
      1: primitive.neutral[10],
      2: primitive.neutral[9],
      3: primitive.neutral[8],
      disabled: primitive.neutral[8],
    },
  },
  content: {
    1: primitive.neutral[10],
    2: primitive.neutral[7],
    3: primitive.neutral[6],
    disabled: primitive.neutral[5],
    primary: primitive.purple[7],
    inverse: {
      1: foundation.white,
      2: primitive.neutral[3],
      3: primitive.neutral[5],
      disabled: primitive.neutral[6],
      primary: primitive.purple[4],
    },
  },
  border: {
    1: primitive.neutral[10],
    2: primitive.neutral[4],
    3: primitive.neutral[3],
    disabled: primitive.neutral[3],
    primary: primitive.purple[7],
    overlay: rgba(primitive.neutral[10], 0.08),
    inverse: {
      1: foundation.white,
      2: primitive.neutral[7],
      3: primitive.neutral[8],
    },
  },
};

export const colors = {
  ...foundation,
  background: 'white',
  text: core.content[1],
  secondaryText: core.content[2],
  tertiaryText: core.content[3],
  border: core.border[2],
  badge: '#ED1C24',
  incomingMessageBackground: core.bg[3],
  incomingMessageText: core.content[1],
  messageInputBackground: core.bg[3],
  avatarBackground: core.bg[3],
  onlineColor: foundation.positive,
};
